import "./XoraDemo.module.css";
import Header from "@/reusable_sections/Header";
import VideoUpload from "./sections/VideoUpload";
import Footer from "@/reusable_sections/Footer";
export default function XoraDemoPage() {
  return <div>
      <Header />
      <VideoUpload />
      <Footer />
    </div>;
}